import script from "./PlatformElementViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformElementViewer.vue?vue&type=script&setup=true&lang=js"

import "./PlatformElementViewer.vue?vue&type=style&index=0&id=46da329d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46da329d"]])

export default __exports__